// agentSlice.js (similar to unitSlice.js)
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAgentsApi,
  addAgentApi,
  updateAgentApi,
  deleteAgentApi,
} from "../services/agentService";
// Fetch all agents
export const fetchAgent = createAsyncThunk("agent/fetchAgent", async () => {
  const response = await fetchAgentsApi();
  console.log("Fetched agents from API:", response);
  return response; // Ensure this returns a valid array
});
// Add a new agent
export const createAgent = createAsyncThunk(
  "agent/createAgent",
  async (agentData) => {
    const response = await addAgentApi(agentData);
    console.log("Create agent API response:", response);
    return response;
  }
);
// Update an existing agent
export const updateAgent = createAsyncThunk(
  "agent/updateAgent",
  async ({ id, agent_name }) => {
    console.log("Sending data for update:", { id, agent_name });
    const response = await updateAgentApi(id, agent_name);
    console.log("Update agent API response:", response);
    return {
      id,
      agent_name,
    };
  }
);
// Delete a agent
export const deleteAgent = createAsyncThunk("agent/deleteAgent", async (id) => {
  const response = await deleteAgentApi(id);
  console.log("Delete API response:", response);
  return {
    id,
  };
});
const agentSlice = createSlice({
  name: "agent",
  initialState: {
    agent: [], // Initial empty array
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch agents
      .addCase(fetchAgent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAgent.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Fetched agents payload:", action.payload);
        // Ensure payload is an array
        if (Array.isArray(action.payload)) {
          state.agent = action.payload;
        } else {
          console.error(
            "Expected payload to be an array, received:",
            action.payload
          );
        }
      })
      .addCase(fetchAgent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Create agent
      .addCase(createAgent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createAgent.fulfilled, (state, action) => {
        state.status = "succeeded";

        console.log("Create agent response payload:", action.payload);

        // Ensure the payload is not empty and it's the expected array
        if (action.payload && action.payload.length > 0) {
          state.agent.push(action.payload[0]); // Only push the first agent into the state
        } else {
          console.error(
            "Unexpected payload structure in createAgent response:",
            action.payload
          );
        }
      })

      .addCase(createAgent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Update agent
      .addCase(updateAgent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateAgent.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Update payload:", action.payload);
        console.log("Current state.agent:", state.agent);

        const index = state.agent.findIndex(
          (agent) => agent.id === action.payload.id
        );
        console.log("Found index:", index);

        if (index !== -1) {
          console.log("Updating agent name...");
          state.agent[index].agent_name = action.payload.agent_name;
          console.log("Updated agent:", state.agent[index]);
        } else {
          console.error("Agent not found to update, adding new agent...");
          state.agent.push(action.payload);
        }
      })

      .addCase(updateAgent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Delete agent
      .addCase(deleteAgent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteAgent.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.agent = state.agent.filter(
          (agent) => agent.id !== action.payload.id
        );
        console.log("Remaining agents after delete:", state.agent);
      })
      .addCase(deleteAgent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});
export default agentSlice.reducer;
